<template>
  <el-dialog
    width="400px"
    :visible.sync="modelValue"
    custom-class="gis-list-create"
  >
    <div class="create-title font-h3">坐标</div>
    <el-input
      type="textarea"
      :rows="15"
      :placeholder="placeholder"
      v-model="polygonString"
    >
    </el-input>
    <div class="create-btn">
      <el-button
        @click="handleConfirmGis"
        class="create-btn-confirm"
        :class="{ 'create-btn-cancel': polygonString }"
        >确定</el-button
      >
      <el-button class="create-btn-cancel" @click="modelValue = false"
        >取消</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { modelMixin } from '../../assets/js/mixins/model';
import { stringToArray } from '../../config/utils';
import { transformCgcs } from '../../api/cgcsToWgsApi';
import { wgs84togcj02 } from '../../config/transformCoodornate';

export default {
  name: 'GisListCreate',
  mixins: [modelMixin],
  props: {
    cgcsParam: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      placeholder: `请用（半角/英文）逗号隔开经纬度，并确保每行对应一个坐标。每个区域请用（半角）分号结尾。
例：
100.0000,20.0000
101.0000,21.0000
102.0000,22.0000
103.0000,23.0000;
110.0000,30.0000
111.0000,31.0000
112.0000,32.0000
113.0000,33.0000;
`,
      polygonString: this.cgcsParam
    };
  },
  methods: {
    async handleConfirmGis() {
      if (this.polygonString) {
        this.$loading({ text: '转换坐标系，需要等待一段时间' });
        let test = true;
        setTimeout(() => {
          if (test) {
            this.$loading().close();
            this.$prompt('转换失败，请重试');
          }
        }, 10000);
        const polygons = this.handleInitStr(this.polygonString);
        const amapStr = await this.stringToArr(this.polygonString);
        this.$loading().close();
        test = false;
        this.$emit(
          'onComfirmPolygons',
          polygons,
          this.polygonString,
          amapStr,
          this.type
        );
      }
    },
    /**
     * 初始化数据格式并检验
     */
    handleInitStr(data) {
      const arr = data.trim().split(';');
      const arrLength = arr.length;
      arr.splice(arrLength - 1, 1);
      let paths = [];
      arr.forEach(items => {
        let path = [];
        let test = items.split('\n');
        if (!test[0]) {
          test.splice(0, 1);
        }
        test.forEach(item => {
          let coodr = item.split(',');
          let coodrObj = {};
          coodrObj.x = coodr[0];
          coodrObj.y = coodr[1];
          path.push(coodrObj);
        });
        path.push(path[0]);
        paths.push(path);
      });
      return paths;
    },

    /**
     * 字符串转二维数组字符串
     */
    async stringToArr(param) {
      const test = stringToArray(param);
      const amapArr = [];
      for (let index = 0; index < test.length; index++) {
        const polygon = [];
        for (let itemIndex = 0; itemIndex < test[index].length; itemIndex++) {
          const { x, y } = await transformCgcs({
            x: test[index][itemIndex][0],
            y: test[index][itemIndex][1]
          });
          const lnglat = wgs84togcj02(x, y);
          polygon.push(lnglat);
        }
        amapArr.push(polygon);
      }
      return JSON.stringify(amapArr);
    }
  }
};
</script>

<style lang="scss">
.gis-list-create {
  .el-dialog {
    &__header {
      padding: 0;
    }
    &__body {
      padding: 28px 24px;
      height: 540px;
      max-height: 80vh;
      overflow-y: auto;
    }
    &__headerbtn {
      display: flex;
      font-size: 30px;
      color: #fff;
      top: -5px;
      right: -40px;
    }
    &__close {
      color: #fff;
    }
  }
  .create-title {
    margin-bottom: 15px;
  }
  .create-btn {
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    margin-top: 70px;
    padding: 0 70px;
    &-confirm {
      background-color: $color-disabled;
    }
    &-cancel {
      background-color: $color-primary;
    }
  }
  .el-button {
    color: #fff;
  }
}
</style>
